import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Slider from 'react-slick';
import isEmpty from 'lodash/isEmpty';

import ProductEditionCard from 'Components/Product/ProductEditions/ProductEditionCard';
import CarouselArrow from 'Components/Carousel/CarouselArrow';
import CarouselPaging from 'Components/Carousel/CarouselPaging';
import useViewport from 'Hooks/useViewport';
import 'Components/Product/ProductEditions/ProductEditions.scss';

const ProductEditions = ({
  name,
  coverType,
  displayType,
  currentPageSlug,
  productEditions,
  presale,
}) => {
  const { isBelowMd } = useViewport();

  if (!currentPageSlug) return false;

  if (isEmpty(productEditions)) return false;

  const editions = productEditions.filter(productEdition => !isEmpty(productEdition.editionPoints));

  const cleanEditions = editions.filter(Boolean);

  if (isEmpty(cleanEditions)) return false;

  if (isBelowMd) cleanEditions.sort(e => (e.selected ? -1 : 1));

  const settings = {
    infinite: false,
    prevArrow: <CarouselArrow ariaLabel="Previous" arrowDirection="left" containerClassName="arrow-btn-container" />,
    nextArrow: <CarouselArrow ariaLabel="Next" arrowDirection="right" containerClassName="arrow-btn-container" />,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: cleanEditions.length < 3,
    dots: true,
    lazyLoad: true,
    initialSlide: 0,
    customPaging: i => (
      <CarouselPaging slideIndex={i} slideLength={cleanEditions.length} slidesToShow={3}/>
    ),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          customPaging: i => (
            <CarouselPaging slideIndex={i} slideLength={cleanEditions.length} slidesToShow={2}/>
          ),
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToScroll: 1,
          slidesToShow: 1,
          swipeToSlide: true,
          customPaging: i => (
            <CarouselPaging slideIndex={i} slideLength={cleanEditions.length} slidesToShow={1}/>
          ),
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToScroll: 1,
          slidesToShow: 1,
          swipeToSlide: true,
          customPaging: i => (
            <CarouselPaging slideIndex={i} slideLength={cleanEditions.length} slidesToShow={1}/>
          ),
        },
      },
    ],
  };
  return (
    <section className="ProductEditions page-section-margin">
      <h2 className="section-title pb-2">
        <FormattedMessage id="producteditions.title" defaultMessage="{name} Editions" values={{ name: productEditions[0].name || name }} />
      </h2>
      <Slider {... settings} className="ProductEditions__Slider">
        {cleanEditions.map(edition =>
          <ProductEditionCard
            key={edition._id}
            presale={presale}
            coverType={coverType}
            displayType={displayType}
            edition={edition}
            currentPageSlug={currentPageSlug}
          />,
        )}
      </Slider>
    </section>
  );
};


ProductEditions.propTypes = {
  name: PropTypes.string,
  coverType: PropTypes.string,
  displayType: PropTypes.string,
  currentPageSlug: PropTypes.string,
  productEditions: PropTypes.arrayOf(PropTypes.object),
  presale: PropTypes.bool,
};

ProductEditions.defaultProps = {
  name: '',
  editions: [],
  coverType: '',
  displayType: '',
  currentPageSlug: '',
  productEditions: [],
  presale: false,
};

export default ProductEditions;
